import { AnonymousStudentErrorType } from "../../../../anonymous-student-interfaces/enumerations/error-type";
import { StudentAPIBaseError } from "./student-api-base-error";

export class StudentAPIUnauthorizedError extends StudentAPIBaseError {
	constructor(message: string = AnonymousStudentErrorType.UNAUTHORIZED) {
		super(message);
		this.name = AnonymousStudentErrorType.UNAUTHORIZED;
	}
}
